import { Resource } from './resource';
import { StateFilterVariables, FilterArgs } from './queryVariables/filters';
/**
 * Abstrakcyjny resource do obsługi listy encji
 *
 * @export
 * @abstract
 * @class EntityListResource
 * @extends {Resource}
 * @template EntityType
 */
export class EntityListResource extends Resource {
    constructor(listName) {
        super();
        /**
         * Zmienne zapytania o listę
         *
         * @protected
         * @memberof EntityResource
         */
        this.listVariables = StateFilterVariables;
        /**
         * Argumenty zapytania o listę
         *
         * @protected
         * @memberof EntityResource
         */
        this.listArgs = FilterArgs;
        this.listQueryName = listName;
    }
    /**
     * Pobranie listy encji
     *
     * @param {Filter} filters
     * @param {boolean} [preventLoader=false]
     * @returns {Promise<ListResponse<EntityType>>}
     * @memberof EntityResource
     */
    list(filters, preventLoader = false, fields = this.listFields) {
        const query = this.prepareOptions({
            query: {
                __variables: this.listVariables,
                [this.listQueryName]: {
                    __args: this.listArgs,
                    list: fields,
                    count: true
                }
            }
        });
        return this.query({ query, variables: { filters } }, this.listQueryName, preventLoader);
    }
}
//# sourceMappingURL=entityList.resource.js.map